<template>
	<div class="mat40">
		<panel-competition-form-box v-if="newAgreements && Object.keys(newAgreements).length > 0 || payAgreements && Object.keys(payAgreements).length > 0" class="panel-form mab24">
			<div class="col-12 mab24">
				<h2>Umowy wymagane do zaakceptowania</h2>
				<p><a href="https://moj.gov.pl/nforms/signer/upload?xFormsAppName=SIGNER" target="_blank" rel="noopener noreferrer">Potrzebujesz pomocy z wypełnieniem formularza? Sprawdź: <b style="text-decoration: underline;">Jak podpisać dokument cyfrowo?</b></a></p>
			</div>
			<div v-if="payAgreements && Object.keys(payAgreements).length > 0" class="agreement-items">
				<PanelAdminPayAgreements v-for="(agreement, index) in payAgreements" :key="index" :id="agreement.id" :agreement="agreement" @update="getAgreementsData" />
			</div>
			<div v-if="newAgreements && Object.keys(newAgreements).length > 0" class="agreement-items">
				<div v-for="(agreement, index) in newAgreements" :key="index" class="agreement-item">
					<b class="agreement-name">Umowa {{ operatorNames(agreement.contractor) }}</b>

						<div class="agreement-date">
							<base-button
								btn9
								icon="dsi dsi-download"
								@click="getSampleAgreement(agreement.principal, agreement.contractor)"
							>
								<span>Pobierz wzór umowy</span>
							</base-button>
						</div>
						<div class="agreement-actions">
							<base-button @click="postAgreement(agreement)" btn1 short>
								<span>AKCEPTUJĘ</span>
							</base-button>
						</div>
				</div>
			</div>
		</panel-competition-form-box>
		<panel-competition-form-box v-if="agreements && Object.keys(agreements).length > 0" class="panel-form mab24">
			<div class="col-12 mab24">
				<h2>Moje umowy</h2>
			</div>
			<div class="agreement-items">
				<div v-for="(agreement, index) in agreements" :key="index" class="agreement-item">
					<b class="agreement-name">Umowa {{ agreement.fvFirmname }}</b>
					<b class="agreement-date">{{ timestampToDate(agreement.addedTime) }}</b>
					<div class="agreement-actions">
						<base-button
							v-if="agreement.link"
							btn9
							icon="dsi dsi-download"
							@click="goToAgreement(agreement.link)"
							:loading="isWaiting"
						>
							<span>Link do umowy</span>
						</base-button>
						<base-button
							v-else
							btn9
							icon="dsi dsi-download"
							@click="downloadAgreement(agreement.secretId)"
							:loading="isWaiting"
						>
							<span>Pobierz umowę</span>
						</base-button>
					</div>
				</div>
			</div>
		</panel-competition-form-box>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import PanelCompetitionFormBox from '@/components/PanelCompetitionFormBox';
import { format, fromUnixTime } from "date-fns";
import { API_ADDRESS } from '@/config';
import PanelAdminPayAgreements from '@/components/PanelAdminPayAgreements';

export default {
	name: 'PanelAccountSettingsAgreements',
	props: {
        id: {
            type: Number,
            default: null,
        },
	},
	components: {
		PanelCompetitionFormBox,
		PanelAdminPayAgreements
	},
	data() {
		return {
			loading: false,
			agreements: null,
			newAgreements: null,
			payAgreements: null,
			files: {},
			isWaiting: false,
		}
	},
	computed: {
        ...mapGetters(['user', 'operators', 'token']),
		operatorId() {
			return this.id ? null : this.user.operator
		},
		organizerId() {
			return this.id || this.user.organizer
		},
		operatorNames() {
			return (id) => {
				if (this.operators[id]) {
					return this.operators[id].name;
				} else {
					this.getOperatorName(id).then(name => {
						this.$set(this.operators, id, { name });
					});
					return '...';
				}
			};
		}
    },
	created() {
		this.getAgreementsData()
	},
	methods: {
		async getAgreementsData() {
			const userId = this.operatorId || this.organizerId
			const promises = []
			const checkAgreements = axios({
				method: 'get',
				url: `/agreement/${userId}/check`,
			})
			promises.push(checkAgreements)


			if (this.operatorId) {
				const checkAgreementsOperator = axios({
					method: 'get',
					url: `/agreement/${userId}/operator`,
				})
				promises.push(checkAgreementsOperator)
			}
			if (this.organizerId) {
				const checkAgreementsOrganizer = axios({
					method: 'get',
					url: `/agreement/${userId}/organizer`,
				})
				promises.push(checkAgreementsOrganizer)
				const payAgreements = axios({
					method: 'get',
					url: `/agreement/${userId}/organizer/pay`,
				})
				promises.push(payAgreements)
			}
			await Promise.all(promises).then((values) => {
				this.newAgreements = values[0]
				this.agreements = values[1]
				this.payAgreements = values[2]
			})
		},
		async postAgreement(agreement) {
			const payload = {
				administrator: agreement.principal,
				processor: agreement.contractor
			}
			try {
				await axios.post(`/agreement/dpa`, payload, {
					headers: {
						'X-Access-Token': this.token
					}
				});
				this.getAgreementsData()
			} catch (e) {
				console.log(e)
				return;
			}
		},
		async getOperatorName(id) {
			const response = await axios({
				method: 'get',
				url: `/panel/operators/${id}`,
			});
			return response.name; 
		},
		timestampToDate(timestamp) {
			return format(fromUnixTime(timestamp), 'dd.MM.yyyy')
		},
		getSampleAgreement(administrator, processor) {
			window.open(`${API_ADDRESS}/agreement/sample?administrator=${administrator}&processor=${processor}`, '_blank')
		},
		goToAgreement(link) {
			window.open(`https://dostartu.pl/${link}`, '_blank')
		},
		async downloadAgreement(secretId) {
			this.isWaiting = true;
			try {
				const pdf = await axios.get(`${API_ADDRESS}/agreement/${secretId}/print`, {
					responseType: "blob",
					headers: {
						'X-Access-Token': this.token
					}
				});
				const pdfBlob = new Blob([pdf], { type: "application/pdf" });
				const url = window.URL.createObjectURL(pdfBlob);
				window.open(url, '_blank');
				
			} catch (error) {
				console.log(error)
			} finally {
				this.isWaiting = false;
			}
			// window.open(`${API_ADDRESS}/agreement/${secretId}/print`, '_blank')
		},
		async payAgreementLink(id) {
			this.isWaiting = true;
			try {
				const pdf = await axios.get(`${API_ADDRESS}/agreement/${id}/pay-competition`, {
					responseType: "blob",
					headers: {
						'X-Access-Token': this.token
					}
				});
				const pdfBlob = new Blob([pdf], { type: "application/pdf" });
				const url = window.URL.createObjectURL(pdfBlob);
				window.open(url, '_blank');
				
			} catch (error) {
				console.log(error)
			} finally {
				this.isWaiting = false;
			}
			// window.open(`${API_ADDRESS}/agreement/${id}/pay-competition`, '_blank');
		},
	}
}
</script>

<style scoped>
.agreement-items {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;
}
.agreement-item {
	border-radius: 4px;
	background-color: var(--color-white, #fff);
    color: var(--color-charcoal-grey-two, #37474f);
	display: flex;
    align-items: center;
    padding: 16px;
}

.agreement-name {
	width: 55%;
}

.agreement-date,
.agreement-actions {
	margin-left: auto;
}

@media (max-width: 991px) {
	.agreement-item {
		flex-wrap: wrap;
	}
	.agreement-actions {
		margin-top: 8px;
		width: 100%;
	}
}
</style>	